import { filtraRegioni } from "../../lookup/Regioni";

export interface IRegioniPertinenza { value: string, label: string };
export interface IUserFormSent {
    nome: string,
    cognome: string,
    regione: string,
    ruolo: string,
    email: string
    password?: string,
    supervisoreId: any,
    supervisoreNominativo?: any,
    aziendaId: string,
    categoriaLavoratoreId: string
    regioniDiPertinenza?: IRegioniPertinenza[]
}

export interface IUserFormUpdate {
    nome: string,
    cognome: string,
    regione: {value: string, label: string} | any,
    ruolo: {value: any, label: string} | any,
    email: string,
    password?: string,
    supervisoreId: {value: any, label: string} | any,
    aziendaId: {value: any, label: string} | any,
    categoriaLavoratoreId: {value: any, label: string} | any,
    regioniDiPertinenza?: string[] | any
}

export function UserAdapterValues(user: any, list: any, aziendaLista: any[], categoriaLista: any[], optionRegioni: any[]) {
    let userMap: IUserFormUpdate;
    const azienda = aziendaLista?.find((el: any) => el.value === user?.aziendaId);
    const category = categoriaLista?.find((el: any) => el.value === user?.categoriaLavoratoreId);
    const region = user?.regioniDiPertinenza?.length > 0 ? filtraRegioni(user.regioniDiPertinenza, optionRegioni) : null;

    return userMap = {
            nome: user?.nome,
            cognome: user?.cognome,
            regione:{value: user?.regione || '', label: user?.regione || ''},
            ruolo: {value: user?.ruolo, label: user?.ruolo},
            email: user?.email,
            supervisoreId: {value: user?.supervisoreId, label: user?.supervisoreNominativo},
            aziendaId: azienda ? azienda : '',
            categoriaLavoratoreId: category ? category : '',
            ...((user?.ruolo?.value === "Operatore" || user?.ruolo === "Operatore") && {regioniDiPertinenza: region})
        } 
}

export function UserAdapterSent(user: IUserFormUpdate) {
    let userMap: IUserFormSent;
    return userMap = {
            nome: user?.nome,
            cognome: user?.cognome,
            regione: user?.regione?.value ? user?.regione?.value : "Tutte",
            ruolo: user?.ruolo?.value || user.ruolo,
            email: user?.email,
            password: user?.password,
            supervisoreId: user?.supervisoreId?.value || null,
            aziendaId: user.aziendaId.value || null,
            categoriaLavoratoreId: user.categoriaLavoratoreId.value || null,
            ...(
            (user?.ruolo?.value === "Operatore" || user?.ruolo === "Operatore") && {
                regioniDiPertinenza: Array.isArray(user?.regioniDiPertinenza)
                ? user.regioniDiPertinenza.map((r: any) => r.value)
                : []
            }
            )
    }
}